import { useAppStore } from '@halo/chat-sdk-react';
import URLs from '@/scripts/request/URLs';
import { debugLevel } from '@/scripts/debug';

export * from '@halo/chat-sdk-react';

useAppStore.getState().createApp({
  base_url: import.meta.env.VITE_BASE_URL,
  file_base_url: import.meta.env.VITE_BASE_URL_FILE,
  media_ws_url: import.meta.env.VITE_QUICKVO_URL_WS,
  media_appid: import.meta.env.VITE_QUICKVO_APP_ID,
  ws_url: new URLs.WS('/api/v1/ws').href,
  debugLevel,
});
